import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getAfterserviceList(param) {
        const response = await service.get(
            `${getApiBaseUrl()}afterservice`,
            param
        );
        return response;
    },

    async getAfterservice(id) {
        const response = await service.get(
            `${getApiBaseUrl()}afterservice/${id}`
        );
        return response;
    },

    async addAfterservice(afterservice) {
        const response = await service.post(
            `${getApiBaseUrl()}afterservice`,
            afterservice
        );
        return response;
    },

    async updateAfterservice(param) {
        const response = await service.patch(
            `${getApiBaseUrl()}afterservice/${param.id}`,
            param.afterservice
        );
        return response;
    },

    async deleteAfterservice(afterservice_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}afterservice/${afterservice_id}`
        );
        return response;
    },

    async verifyPin(args) {
        const response = await service.post(
            `${getApiBaseUrl()}afterservice/verify`,
            args
        );
        return response;
    },
};
